export default { sha: '924bec1f822e5ad2e449dbb757f119cd720fb428', buildNumber: 'undefined' }
